import * as React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { FieldError } from "./FieldError";

export function TargetPriceStep() {
  const { control, register } = useFormContext();
  const vehicles = useWatch({ control, name: "step6.vehicles" }) || [];
  const totalVehicles = vehicles.length;

  if (totalVehicles < 6) {
    return (
      <div className="rounded-lg border border-slate-200 bg-white p-6 text-sm text-slate-600">
        Target price per truck is only required for quotes with 6 or more vehicles.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-2xl font-semibold text-slate-900">Target Price</h2>
        <p className="text-sm text-slate-600">
          Provide the target price per truck for this account.
        </p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="targetPricePerTruck">
          Target price per truck <span className="text-red-600">*</span>
        </Label>
        <Input
          id="targetPricePerTruck"
          placeholder="Enter amount"
          {...register("step10.targetPricePerTruck")}
        />
        <FieldError step="step10" name="step10.targetPricePerTruck" />
      </div>
    </div>
  );
}
